import { useEffect } from "react";

import { datadogLogs } from "@datadog/browser-logs";

export const InvalidThemeErrorMessage = () => {
  useEffect(() => {
    datadogLogs.logger.error("A user face issue: The theme you are using does not support this component.");
  }, []);

  return <div>The theme you are using does not support this component.</div>;
};
